import React from "react";
import ListPage from "../../base/ListPage.js";
import APILXD from "../../../http/APILXD.js";
import { Button, Modal, message, Space } from "antd";
import TimeHelp from "../../../tool/TimeHelp";
import ModalBase from "../../../components/modalBase/index";
import HttpTool from "../../../tool/HttpTool";
import styles from "./Company.less";
import { ProTable } from "@ant-design/pro-components";
import dayjs from "dayjs";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Tooltip, Tag } from "antd";

const MB = new ModalBase();

function ExpirationTime({ remainingTime }) {
  function formatDuration(minutes) {
    if (minutes < 0 || !minutes || typeof minutes !== 'number') {
      return '--';
    }

    if (minutes < 60) {
      if (minutes > 0 && minutes < 1) {
        return `1 分钟`;
      }
      return `${Math.floor(minutes)} 分钟`;
    }

    const days = Math.floor(minutes / (60 * 24));
    const hours = Math.floor((minutes % (60 * 24)) / 60);
    const remainingMinutes = Math.floor(minutes % 60);

    let result = '';

    if (days >= 3) {
      result += `${days} 天 `;
      return result.trim();
    }
    if (days > 0) {
      result += `${days} 天 `;
    }
    if (hours > 0 || days > 0) {
      result += `${hours} 小时 `;
    }
    if (remainingMinutes > 0 || (days === 0 && hours === 0)) {
      result += `${remainingMinutes} 分钟`;
    }

    return result.trim();
  }
  const remainingTimeDispose = (pastTime) => {
    if (pastTime && typeof pastTime === 'number') {
      const remaining = pastTime - new Date().getTime();
      const data = dayjs(pastTime).format('YYYY-MM-DD HH:mm:ss');
      if (remaining <= 0) {
        return (
          <span style={{ flexShrink: 0}}>
            <Tooltip title={<div>到期时间:{data}</div>}>
              <p style={{ color: 'red' }}>
                <ExclamationCircleOutlined /> 已到期
              </p>
            </Tooltip>
          </span>
        );
      }
      return (
        <>
          <Tooltip title={<div>到期时间:{data}</div>}>
            <p style={{ color: remaining / 86400000 <= 3 ? 'red' : 'rgba(111, 79, 242, 1)' }}>{formatDuration(remaining / 60000)}后到期</p>
          </Tooltip>
        </>
      );
    } else {
      return <></>;
    }
  };

  return <>{dayjs(remainingTime).format('YYYY-MM-DD HH:mm:ss')}{remainingTimeDispose(remainingTime)}</>;
}

/**
 * 数字人状态映射
 */
export const HumanStatusMap = {
  1: { text: '缺勤', color: '#F5883A' },
  3: { text: '忙碌', color: '#1B8BE6' },
  2: { text: '空闲', color: '#5EC075' },
  4: { text: '停工', color: '#EE4B4B' },
};

class Corporation extends ListPage {
  constructor(props) {
    super(props);
  }

  base_getListConfig() {
    return {
      table: {
        columns: this.getTableColumns(),
        url: APILXD.corporationIndex,
        otherParam: null,
      },
      new: {},
      search: {
        seniorSearch: this.getSeniorSearch(),
        option: {
          openSenior: true,
          placeholder: "请输入公司名称搜索",
          reg: /^[\s\S]*$/,
          beforeSubmit: (value) => {
            if (value.keyword) {
              value.name = value.keyword;
            }
            delete value.keyword;

            return true;
          },
        },
      },
    };
  }

  getSeniorSearch() {
    return {
      colCount: 3,
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18, offset: 0 },
      },
      parameterArr: [
        {
          field: "status",
          name: "状态",
          type: "select",
          selectType: "value",
          reg: (v) => {
            return true;
          },
          option: {
            defaultValue: {
              key: "全部状态",
              value: "",
            },
          },
          data: [
            {
              title: "全部状态",
              value: "",
            },
            {
              title: "启用",
              value: 1,
            },
            {
              title: "停用",
              value: 2,
            },
          ],
        },
      ],
    };
  }

  changeAccountStatus(id, status) {
    let param = {
      id,
      status,
    };
    let successCB = (code, msg, json, option) => {
      this.setState({ loading: false }, () => {
        message.success("操作成功");
        this._loadDataForNet();
      });
    };
    let failureCB = (code, msg) => {
      this.setState({ loading: false }, () => {
        message.error(msg);
      });
    };

    this.setState({ loading: true });

    HttpTool.post(APILXD.corporationEnable, successCB, failureCB, param);
  }

  /**
   *  列表数据配置
   */
  getTableColumns() {
    return [
      {
        title: "企业名称",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "成员数量",
        dataIndex: "seatCount",
        key: "seatCount",
        render: (text, record) => {
          return (
            <Button
              type="link"
              onClick={() => {
                this.seatCountList(record);
              }}
            >
              {text}
            </Button>
          );
        },
      },
      {
        title: "设备数量",
        dataIndex: "deviceCount",
        key: "deviceCount",
        render: (text, record) => {
          return (
            <Button
              type="link"
              onClick={() => {
                this.deviceList(record);
              }}
            >
              {text}
            </Button>
          );
        },
      },
      {
        title: "职业数量",
        dataIndex: "capPositionCount",
        key: "capPositionCount",
        render: (text, record) => {
          return (
            <Button
              type="link"
              onClick={() => {
                this.positionList(record);
              }}
            >
              {text}
            </Button>
          );
        },
      },
      {
        title: "状态",
        dataIndex: "status",
        key: "status",
        render: (text) => {
          return text == 1 ? (
            <span style={{ color: "green" }}>启用</span>
          ) : (
            <span style={{ color: "red" }}>停用</span>
          );
        },
      },
      {
        title: "管理员",
        dataIndex: "mobile",
        key: "mobile",
      },
      {
        title: "注册时间",
        dataIndex: "addTime",
        key: "addTime",
        render: (text) => {
          let time = TimeHelp.getYMDHM(text);
          return <div>{time}</div>;
        },
      },
      {
        title: "操作",
        width: 200,
        render: (text, record, index) => {
          return (
            <div>
              {this.powerConfig.Edit ? (
                record.status === 1 ? (
                  <span
                    onClick={() => {
                      this.changeState(record._id, 2);
                    }}
                    style={{ color: "red" }}
                    className={styles.clickable}
                  >
                    {"停用"}
                  </span>
                ) : (
                  <span
                    onClick={() => {
                      this.changeState(record._id, 1);
                    }}
                    style={{ color: "green" }}
                    className={styles.clickable}
                  >
                    {"启用"}
                  </span>
                )
              ) : null}
            </div>
          );
        },
      },
    ];
  }

  positionList(record) {
    console.log("record", record);
    Modal.confirm({
      title: "企业职业列表",
      width: "1000px",
      closable: true,
      icon: null,
      content: (
        <div style={{ width: "960px", height: 640 }}>
          <ProTable
            bordered={false}
            actionRef={(ref) => (this.tableRef = ref)}
            key="_id"
            rowKey="_id"
            style={{ height: 600 }}
            setting={false}
            scroll={{
              y: 460,
            }}
            search={false}
            columns={[
              {
                title: "职业",
                dataIndex: "name",
                key: "name",
              },
              {
                title: "到期时间",
                dataIndex: "addTime",
                key: "addTime",
                width: 220,
                render: (text, record) => {
                  const isBuy = record.sourceType === 'buy';
                  const isFree = record.sourceType === 'free';
                  
                  return (isBuy || isFree) && record.pricePackageEndTime ? <ExpirationTime remainingTime={record.pricePackageEndTime} /> : '--';
                },
              },
            ]}
            request={(params) => {
              return new Promise((resolve, reject) => {
                let myParams = { companyId: record._id, ...params };
                console.log("myParams", myParams);
                HttpTool.post(
                  APILXD.corporationCapPositionList,
                  (code, msg, json, option) => {
                    this.setState({ loading: false });
                    console.log("json----》", json);
                    resolve({
                      data: json,
                      success: true,
                      total: json?.length,
                    });
                  },
                  (code, msg) => {},
                  myParams,
                );
              });
            }}
          ></ProTable>
        </div>
      ),
      footer: null,
    });
  }

  seatCountList(record) {
    console.log("record", record);
    Modal.confirm({
      title: "企业成员",
      width: "800px",
      closable: true,
      icon: null,
      content: (
        <div style={{ width: "760px", height: 650 }}>
          <ProTable
            bordered={false}
            actionRef={(ref) => (this.tableRef = ref)}
            styles={{
              content: {
                paddingInline: "0px",
              },
            }}
            key="_id"
            rowKey="_id"
            style={{ height: 640 }}
            scroll={{
              y: 500,
            }}
            search={false}
            columns={[
              {
                title: "成员",
                dataIndex: "name",
                key: "name",
                width: 220,
                render: (text, record) => (
                  <Space align="center">
                    <img
                      style={{ width: 32, height: 32 }}
                      src={record.avatar}
                    />
                    <span>{record.nickname}</span>
                  </Space>
                ),
              },
              {
                title: "手机号",
                dataIndex: "mobile",
                key: "mobile",
              },
            ]}
            request={(params) => {
              return new Promise((resolve, reject) => {
                let myParams = { companyId: record._id, ...params };
                HttpTool.post(
                  APILXD.corporationMemberList,
                  (code, msg, json, option) => {
                    this.setState({ loading: false });
                    console.log("json----》", json);
                    resolve({
                      data: json,
                      success: true,
                      total: json?.length,
                    });
                  },
                  (code, msg) => {},
                  myParams,
                );
              });
            }}
          ></ProTable>
        </div>
      ),
      footer: null,
    });
  }

  deviceList(record) {
    console.log("record", record);
    Modal.confirm({
      title: "企业设备列表",
      width: "1000px",
      closable: true,
      icon: null,
      content: (
        <div style={{ width: "960px", height: 650 }}>
          <ProTable
            bordered={false}
            actionRef={(ref) => (this.tableRef = ref)}
            key="_id"
            rowKey="_id"
            style={{ height: 640 }}
            scroll={{
              y: 500,
            }}
            search={false}
            columns={[
              {
                title: "数字人",
                dataIndex: "name",
                key: "name",
                render: (text, record) => ( 
                  <Space align="center">
                    <img
                      style={{ width: 32, height: 32, borderRadius: "50%" }}
                      src={record.avatar}
                    />
                    <span>{record.name}</span>
                  </Space>
                ),
              },
              {
                title: "设备编号",
                dataIndex: "deviceId",
                key: "deviceId",
              },
              {
                title: "状态",
                dataIndex: "status",
                key: "status",
                render: (text1, record) => { 
                  const { color, text } = HumanStatusMap[record?.status || 4];

                  return (
                  <Space>
                    <Tag
                      color={
                        color
                      }
                    >
                      {text}
                    </Tag>
                  </Space>
                )}
              },
              {
                title: "到期时间",
                dataIndex: "deviceExpireTime",
                key: "deviceExpireTime",
                width: 120,
                render: (text) => {
                  let time = TimeHelp.getYMDHMS(text);
                  return <div>{time}</div>;
                },
              },
            ]}
            request={(params) => {
              return new Promise((resolve, reject) => {
                let myParams = { companyId: record._id, ...params };
                console.log("myParams", myParams);
                HttpTool.post(
                  APILXD.corporationDeviceList,
                  (code, msg, json, option) => {
                    this.setState({ loading: false });
                    console.log("json----》", json);
                    resolve({
                      data: json,
                      success: true,
                      total: json?.length,
                    });
                  },
                  (code, msg) => {},
                  myParams,
                );
              });
            }}
          ></ProTable>
        </div>
      ),
      footer: null,
    });
  }

  changeState(id, status) {
    Modal.confirm({
      title: "提示",
      content: "确定" + (status === 1 ? "启用" : "停用") + "该企业吗",
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        let param = {
          companyId: id,
          status,
        };
        let successCB = (code, msg, json, option) => {
          this.setState({ loading: false }, () => {
            message.success("操作成功");
            this._loadDataForNet();
          });
        };
        let failureCB = (code, msg) => {
          this.setState({ loading: false }, () => {
            message.error(msg);
          });
        };

        this.setState({ loading: true });

        HttpTool.post(APILXD.corporationEnable, successCB, failureCB, param);
      },
    });
  }
}

module.exports = Corporation;
